import type { SvgIconProps } from '@mui/material';
import PyMuiMenuItem from '../../components/generalComponents/PyMuiMenuItem';
import { AIGradientIcon } from './AIGradientIcon';
import { MenuItem, ShortcutText } from './styles';

type AIMenuItemProps = {
  testId: string;
  onClick: () => void;
  icon: React.ComponentType<SvgIconProps>;
  label: string;
  shortcut?: string;
};

export const AIMenuItem = ({ testId, onClick, icon: IconComponent, label, shortcut }: AIMenuItemProps) => (
  <PyMuiMenuItem
    testId={testId}
    onClick={onClick}
    menuItem={
      <MenuItem>
        <AIGradientIcon icon={(id) => <IconComponent fontSize="medium" sx={{ fill: `url(#${id})` }} />} />
        {label}
        {shortcut && <ShortcutText>{shortcut}</ShortcutText>}
      </MenuItem>
    }
  />
);
